import { render, staticRenderFns } from "./Fttx.vue?vue&type=template&id=b5e34668"
import script from "./Fttx.vue?vue&type=script&lang=js"
export * from "./Fttx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports